import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { db } from '../../firebase'; // Firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

function Callfrom() {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "Call Back"), {
        ...formData,
        createdAt: serverTimestamp()
      });
       alert("Message sent!");
      setFormData({ name: '',  mobile: ''});
    } catch (err) {
      alert("Error saving data: " + err.message);
    }
  };
const navigate = useNavigate();
  return (
    <form onSubmit={handleSubmit}>
      <input className='me-2 mt-3' name="name" onChange={handleChange} value={formData.name} placeholder="Name" required />
      <input className='me-2 mt-3' name="mobile" onChange={handleChange} value={formData.mobile} placeholder="Mobile No." required />

        <button className='messagedata mt-2' type="submit">Call Me Back</button>
     
    </form>
  );
}

export default Callfrom;
